<template>
  <div class="language-selector">
    <button 
      @click="toggleDropdown" 
      class="flex items-center space-x-1 text-sm font-medium transition-colors hover:opacity-80 px-2 py-1 rounded whitespace-nowrap"
      :class="buttonClasses"
    >
      <span>{{ currentLanguageLabel }}</span>
      <svg 
        class="w-3 h-3 transition-transform duration-200"
        :class="{ 'rotate-180': isOpen }"
        fill="none" 
        stroke="currentColor" 
        viewBox="0 0 24 24"
      >
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
      </svg>
    </button>
    
    <!-- Dropdown -->
    <div 
      v-if="isOpen" 
      class="absolute top-full right-0 mt-1 bg-white border border-gray-200 rounded shadow-lg z-50 min-w-[140px]"
    >
      <div class="py-1 flex flex-col">
        <button 
          v-for="lang in languages" 
          :key="lang.code"
          @click="changeLanguage(lang.code)"
          class="w-full px-3 py-2 text-left text-sm hover:bg-gray-50 transition-colors"
          :class="{ 'bg-gray-50 font-medium': currentLocale === lang.code }"
        >
          {{ lang.label }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed, onMounted, onUnmounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter, useRoute } from 'vue-router'

export default {
  name: 'LanguageSelector',
  props: {
    buttonClasses: {
      type: String,
      default: 'text-black'
    }
  },
  setup() {
    const { locale } = useI18n()
    const router = useRouter()
    const route = useRoute()
    const isOpen = ref(false)
    
    const languages = [
      { code: 'pt', label: 'Português', short: 'PT', routeCode: 'pt' },
      { code: 'en-US', label: 'English', short: 'EN', routeCode: 'en' }
    ]
    
    const currentLocale = computed(() => locale.value)
    
    const currentLanguageLabel = computed(() => {
      const lang = languages.find(l => l.code === currentLocale.value)
      return lang ? lang.short : 'PT'
    })
    
    const toggleDropdown = () => {
      isOpen.value = !isOpen.value
    }
    
    const changeLanguage = (langCode) => {
      
      // Encontrar o código da rota correspondente
      const lang = languages.find(l => l.code === langCode)
      const newRouteLocale = lang ? lang.routeCode : 'en'
      
      // Extrair a rota atual sem o prefixo de idioma
      const currentPath = route.path
      const pathWithoutLocale = currentPath.replace(/^\/(en|pt)/, '') || ''
      
      // Construir nova rota com o novo idioma
      const newPath = `/${newRouteLocale}${pathWithoutLocale}`
      
      
      // Navegar para a nova rota
      router.push(newPath)
      
      isOpen.value = false
    }
    
    // Fechar dropdown quando clicar fora
    const closeDropdown = (event) => {
      if (!event.target.closest('.language-selector')) {
        isOpen.value = false
      }
    }
    
    onMounted(() => {
      document.addEventListener('click', closeDropdown)
    })
    
    onUnmounted(() => {
      document.removeEventListener('click', closeDropdown)
    })
    
    return {
      isOpen,
      languages,
      currentLocale,
      currentLanguageLabel,
      toggleDropdown,
      changeLanguage
    }
  }
}
</script>

<style scoped>
.language-selector {
  position: relative;
  display: inline-block;
}
</style> 